import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AiFillDelete, AiOutlineScissor } from 'react-icons/ai';
import styled from 'styled-components';
import { getDynamicMapElementName } from '../../helper/displayHelpers';
import { getIconForElementPartOfText } from '../../helper/mapElementIconHelper';
import { undoableMapEditorDynamicMapElementCut } from '../../stores/undo/operation/MapEditorDynamicMapElementCut';
import { DynamicMapElementChangeGroup, groupUndoableMapEditorDynamicMapElementChanges } from '../../stores/undo/operation/MapEditorSubmitCurrentMapDynamicMapElementsChangesOp';
import { MenuCard } from '../menu/MenuCard';
import { MenuCardLabel } from '../menu/MenuCardLabel';
import { LayerDeleteButton, LayerEditButton } from './EditorTileInspectorLayer';
const TitleBar = styled.div.withConfig({
  displayName: "DynamicMapElementPropertiesSharedElements__TitleBar",
  componentId: "sc-1t81mra-0"
})(["display:flex;"]);
const TitleName = styled(MenuCardLabel).withConfig({
  displayName: "DynamicMapElementPropertiesSharedElements__TitleName",
  componentId: "sc-1t81mra-1"
})(["flex-grow:1;"]);
const Buttons = styled.div.withConfig({
  displayName: "DynamicMapElementPropertiesSharedElements__Buttons",
  componentId: "sc-1t81mra-2"
})(["flex-shrink:0;"]);
export const Input = styled.input.withConfig({
  displayName: "DynamicMapElementPropertiesSharedElements__Input",
  componentId: "sc-1t81mra-3"
})(["width:100%;"]);
const WarningMessage = styled.span.withConfig({
  displayName: "DynamicMapElementPropertiesSharedElements__WarningMessage",
  componentId: "sc-1t81mra-4"
})(["color:red;"]);
export const LabelInput = observer(({
  element,
  allElements,
  alreadyUsedWarningLabelKey,
  onChange
}) => {
  const {
    t
  } = useTranslation();
  const {
    label
  } = element;
  const labelAlreadyUsed = label && allElements.some(otherElement => otherElement != element && otherElement.label === label);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.element_label"), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Input, {
    type: "text",
    value: element.label,
    onChange: ({
      target
    }) => onChange(target.value)
  }))), labelAlreadyUsed ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(WarningMessage, null, t(alreadyUsedWarningLabelKey)))) : null);
});
const IconContainer = styled.div.withConfig({
  displayName: "DynamicMapElementPropertiesSharedElements__IconContainer",
  componentId: "sc-1t81mra-5"
})(["width:24px;flex-grow:0;flex-shrink:0;"]);
export const ElementTitleDisplay = observer(({
  element,
  elementTypeKey,
  name
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(TitleName, null, /*#__PURE__*/React.createElement(IconContainer, null, getIconForElementPartOfText(element)), /*#__PURE__*/React.createElement("div", null, t(elementTypeKey), /*#__PURE__*/React.createElement("br", null), name));
});
export const DynamicMapElementPropertiesEditorTemplate = observer(({
  element,
  elementTypeKey,
  mapEditorStore,
  children
}) => {
  const isCut = element.$modelId === mapEditorStore.cutDynamicMapElementModelId;

  const deleteElement = () => {
    groupUndoableMapEditorDynamicMapElementChanges(DynamicMapElementChangeGroup.Delete, () => {
      mapEditorStore.currentMapStore.currentMap.removeDynamicMapElement(element);
    });
  };

  const name = getDynamicMapElementName(element, false);
  return /*#__PURE__*/React.createElement(MenuCard, null, /*#__PURE__*/React.createElement(TitleBar, null, /*#__PURE__*/React.createElement(ElementTitleDisplay, {
    element: element,
    elementTypeKey: elementTypeKey,
    name: name
  }), /*#__PURE__*/React.createElement(Buttons, null, /*#__PURE__*/React.createElement(LayerEditButton, {
    disabled: isCut,
    onClick: () => undoableMapEditorDynamicMapElementCut(element, mapEditorStore)
  }, /*#__PURE__*/React.createElement(AiOutlineScissor, null)), /*#__PURE__*/React.createElement(LayerDeleteButton, {
    onClick: deleteElement
  }, /*#__PURE__*/React.createElement(AiFillDelete, null)))), children);
});